import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("odismap_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("odismap_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("odismap_user", JSON.stringify(data));
    } catch {
      setUser(null);
      localStorage.removeItem("odismap_token");
      localStorage.removeItem("odismap_user");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Race-condition guard: se siamo nel flow OAuth, AuthCallback gestirà /auth/me dopo lo scambio token
    if (window.location.pathname === "/auth/google/callback") {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("odismap_token", data.access_token);
    localStorage.setItem("odismap_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name, nickname, referralCode = null) => {
    const payload = { email, password, name, nickname };
    if (referralCode) payload.referral_code = referralCode;
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("odismap_token", data.access_token);
    localStorage.setItem("odismap_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("odismap_token");
    localStorage.removeItem("odismap_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, loading, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
